var randomID = function randomID(name) {
  return "".concat(name + Math.floor(Math.random() * 100000), "-id-").concat(Math.floor(Math.random() * 100000));
};

export default randomID;